import { CrosswalkInput } from '@kinetic-ui/data-layer';
import { recoilKeys } from 'const/recoilKeys';
import { atom, useRecoilState } from 'recoil';
import { RecursivePartial } from 'types/util';

export const selectedCrosswalkState = atom<RecursivePartial<CrosswalkInput> | undefined>({
  key: recoilKeys.SELECTED_CROSSWALK,
  default: undefined,
});

export const useSelectedCrosswalk = () => {
  const [selectedCrosswalk, setSelectedCrosswalk] = useRecoilState(selectedCrosswalkState);

  return { selectedCrosswalk, setSelectedCrosswalk };
};
